import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "dceptnz_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve a stored relative file url (e.g. /api/files/...) to an absolute URL
export const fileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export const HERO_VIDEO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_dcep-research-nz/artifacts/q4ykpurl_download.mp4";
export const LOGO_MARK_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_dcep-research-nz/artifacts/ig0n3agx_Screenshot%202026-10-05%20at%207.17.04%E2%80%AFpm.png";
export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_fc051c9e-b234-42bb-bbe4-b31d9b891589/artifacts/8h16gzad_Untitled%20Project%20-%20Artboard%2016%20%281%29.png";
